import Helpers from '../../../../utils/helper';
import { ActionDocumentType } from './enums/action-document-type.enum';
import { DocumentDetailsContentType } from './enums/document-details-content-type';
import { DocumentDetailsContentSubtype } from './enums/document-details-content-subtype';
import { DocumentDetailsStatus } from './enums/document-details-status.enum';
import { DocumentBuyerVisibilityConditions } from './enums/engagement-document-party-buyer-visibility-conditions';
import { DocumentPartyVisibility } from './enums/engagement-document-party-visibility';
import { EngagementDocumentSource } from './enums/engagement-document-source';
import { TimelineParty } from './enums/timeline-party.enum';
import { generateGuid } from '../../../../utils/typedHelper';

export interface DocumentDetails {
    id: string;
    name: string;
    status: DocumentDetailsStatus;
    counterParty: TimelineParty;
    sectionId: string;
    type: ActionDocumentType;
    contentType: DocumentDetailsContentType;
    isUnregisteredFile: boolean;
    source: EngagementDocumentSource;
    masterDocumentId: string;
    additionalVersionIds?: string[];
    contentSubtype?: DocumentDetailsContentSubtype;
    toRemove?: boolean;
    temporaryFileId?: number;
    localFile?: File;
    templateId?: number;
    linkedProjectId?: string;
    questionnaireId?: number;
    questionnaireSnapshotId?: number;
    dataTableViewId?: number;
    dataTableConditionalColumnId?: string;
    dataTableConditionalValues?: string[];
    fileName?: string;
    datePosted?: Date;
    isPrepared?: boolean;
    isEngagementLetter?: boolean;
    engagementBuyerId?: number;
    fileUrl?: string;
    partyVisibility?: DocumentPartyVisibility;
    buyerVisibilityConditions?: DocumentBuyerVisibilityConditions[];
    isManualDocument: boolean;
    oldManualReferenceIds?: string[];
    hasPendingChanges: boolean;
}

export const createDefaultDocumentDetails = (
    isNew: boolean,
    masterDocumentId?: string,
    type?: ActionDocumentType,
    subType?: DocumentDetailsContentSubtype,
    source?: EngagementDocumentSource,
    party?: TimelineParty,
    isManual?: boolean
): DocumentDetails => {
    const id = generateGuid();

    return {
        id: id,
        name: '',
        status: DocumentDetailsStatus.RequiresAction,
        counterParty: party ?? TimelineParty.Buyer,
        sectionId: '',
        masterDocumentId: masterDocumentId ?? id,
        additionalVersionIds: [],
        type: type ?? (-1 as ActionDocumentType),
        contentType: DocumentDetailsContentType.General,
        contentSubtype: subType,
        isUnregisteredFile: isNew,
        toRemove: false,
        source: source ?? (-1 as EngagementDocumentSource),
        templateId: 0,
        fileName: '',
        questionnaireId: -1,
        linkedProjectId: '',
        isManualDocument: !!isManual,
        hasPendingChanges: false,
    };
};
